
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Constants.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export class MailTemplateParameters {
	static contactPerson: MailTemplateParametersType = 'kontaktperson';
	static settlementNumber: MailTemplateParametersType = 'forligsnummer';
	static currentDate: MailTemplateParametersType = 'dagsDato';
	static settlementProductPlans: MailTemplateParametersType = 'forligsProduktPlaner';

	static values = ['kontaktperson', 'forligsnummer', 'dagsDato', 'forligsProduktPlaner'];
}
export type MailTemplateParametersType = 'kontaktperson' | 'forligsnummer' | 'dagsDato' | 'forligsProduktPlaner';

